module.exports = __webpack_public_path__ + "static/media/almacenaje.52e0f159.png";